import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
interface Props {
  size?: number;
  color?: 'primary'|'secondary'|'inherit';
}
const LoadingIndicator: React.FC<Props> = (props) => {
  return (
    <CircularProgress
      size={props.size || 16}
      color={props.color}
    />
  );
};

export default LoadingIndicator;
